import React, { FC, ReactNode } from 'react';

import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';

import styles from './ProvisionPage.module.scss';

const sectionId = 'ProvisionPage';

interface ProvisionPageProps {
  header: ReactNode;
  content: {
    header?: ReactNode;
    main?: ReactNode;
    footer?: ReactNode;
  };
}

const ProvisionPage: FC<ProvisionPageProps> = ({
  header,
  content,
}) => (
  <Page
    main={(
      <PageMain
        header={<PageMainHeader start={header} />}
        main={(
          <div className={styles.content}>
            <div className={styles.content_header}>
              {content.header}
            </div>
            <div className={styles.content_main}>
              {content.main}
            </div>
            <div className={styles.content_footer}>
              {content.footer}
            </div>
          </div>
        )}
      />
    )}
  />
);

export type { ProvisionPageProps };
export { ProvisionPage, sectionId };
